import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { AutocompleteInput, required, TextInput } from 'react-admin';
import useStyles from '../../QuickActions/styles';
import { commonVehicleColors } from '../../VehicleConstants';

const NonAutomobileForm = ({
  labelActive,
  years,
  makeList,
  modelList,
  vehicle,
  touched,
  handleTouched,
  handleChange,
  setModelList,
  nonautomobileData,
}) => {
  const classes = useStyles();

  const hasMakeError =
    !!makeList.length &&
    !vehicle?.[labelActive]?.make &&
    touched[labelActive].make;

  return (
    <Box>
      <Grid
        container
        spacing={1}
        className={`${classes.formRoot} ${classes.width100}`}
      >
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Year"
            source={`${labelActive}.year`}
            choices={years}
            onChange={(value) => handleChange('year', value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Make"
            source={`${labelActive}.make`}
            choices={makeList}
            validate={[required()]}
            onChange={(value) => {
              handleChange('make', value);
              if (value !== 'other') {
                setModelList([
                  ...nonautomobileData[value].map((model) => ({
                    id: model,
                    name: model,
                  })),
                  { id: 'other', name: 'Other' },
                ]);
              } else {
                setModelList([{ id: 'other', name: 'Other' }]);
              }
            }}
            options={{
              error: hasMakeError,
            }}
            helperText={hasMakeError && 'Required'}
            onBlur={handleTouched('make')}
          />
          {vehicle?.[labelActive]?.make === 'other' && (
            <TextInput
              source="custom.make"
              label="Custom Make"
              validate={[required()]}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {!(
            modelList.length === 1 && vehicle?.[labelActive]?.model === 'other'
          ) && (
            <AutocompleteInput
              label="Model"
              source={`${labelActive}.model`}
              choices={modelList}
              onChange={(value) => handleChange('model', value)}
            />
          )}

          {vehicle?.[labelActive]?.model === 'other' && (
            <TextInput source="custom.model" label="Custom Model" />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Color"
            source={`${labelActive}.color`}
            choices={commonVehicleColors}
            onChange={(value) => handleChange('color', value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default NonAutomobileForm;
